<div class="row mhide">
 <div class="col-md-12 nopad">
 <div class="col-md-12 nopad mobile_hide">
 <div class="w_79" style="position: fixed;z-index: 99; ">
 <div class="tabs-header border-bottom">
 <ul>
 <li *ngFor="let data of appservice.User_Role_Menu" [className]="appservice.URL_Location==data.Link ? 'active' : ''" class="" > <a (click)="appservice.load_page(data.Link)">{{data.Menu}}</a></li>
 </ul>
 </div>
 </div>
 </div>

 <div class="col-md-12 nopad">
 <div class="spin_block" *ngIf="appservice.isload">
 <div class="d-flex justify-content-center">
 <div class="spinner-border text-primary" role="status">
 <span class="sr-only">Loading...</span>
 </div>
 </div>
 </div>
 <div class="m_2 res_table border" style="padding: 10px;">
 <div class="row filter-row">
 <div class="col-sm-6 col-md-2 col-xs-6">
 <div class="form-group ">
 <label class="control-label">User Role:</label>
 <select class="select2-option form-control " [(ngModel)]="Selected_Rights" name="UM_Rights" #UM_Rights="ngModel" style="width:100%" aria-hidden="true">
 <option *ngFor="let summary of Rights_Row" value={{summary.value}}>
 {{summary.label}}
 </option>
 </select>
 </div>
 </div>
 <div class="col-sm-6 col-md-2 col-xs-6">
 <div class="form-group ">
 <label class="control-label">Module Name:</label>
 <select class="select2-option form-control " [(ngModel)]="Selected_Module" name="Module_Name" #Module_Name="ngModel" style="width:100%" aria-hidden="true">
 <option *ngFor="let summary of Module_Row" value={{summary.value}}>
 {{summary.label}}
 </option>
 </select>
 </div>
 </div>
 <div class="col-sm-6 col-md-2 col-xs-6">
 <label class="control-label">&nbsp;</label>
 <a href="javascript:" (click)="display()" class="btn btn-success btn-block" style="height: 35px"> Show </a>
 </div>
 <div class="col-sm-6 col-md-2 col-xs-6">
 <label class="control-label">&nbsp;</label>
 <button *ngIf="Row.length>0" (click)="save()" [disabled]="btndisable" class="btn btn-info btn-block" style="height: 35px"> 
 <span *ngIf="btndisable==true" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
 <i *ngIf="btndisable==false" class='bx bx-paper-plane'></i> Save
 </button>
 </div>
 </div>
 
 <div class="row">
 <div class="col-md-12">
 <input type="checkbox" [(ngModel)]="Selected" (change)="select()" > Check All
 </div>
 <div class="col-md-12">
 <div class="entry_table1">
 <div class="header">
 <div style="width:50px; text-align: center;">#</div>
 <div *ngFor="let data of rs" style="padding-left: 8px; padding-right: 10px;" [style.text-align]="data.align" [style.width]="data.width">{{data.Name}}</div>
 </div>
 <div class="body" *ngFor="let rowData of Row;index as i">
 <div class="row_hover" style="width:50px; text-align: center;">{{i+1}}</div>
 <div *ngFor="let data of rs" class="in cell row_hover" [style.width]="data.width">
 <input *ngIf="data.Field=='Check'" [(ngModel)]="rowData[data.Field]" [style.text-align]="data.align"
 type="Checkbox" class="in tbtext" style="width: 100%;">
 <input *ngIf="!(data.Field=='Check')" [(ngModel)]="rowData[data.Field]" [style.text-align]="data.align"
 type="{{data.type}}" class="in tbtext" style="width: 100%;"
 value="{{rowData[data.Field]}}">
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
</div>

<!-- Modernized Mobile View for Role Permissions Mapping -->
<div class="row mshow">
 <!-- Sticky Header -->
 <div class="sticky-header">
 <li (click)="appservice.back()" class="bx bx-left-arrow-alt back-btn"></li>
 <label class="header-title-mobile">Role Permissions</label>
 <button [disabled]="btndisable" (click)="save()" class="save-icon-btn">
 <i *ngIf="!btndisable" class='bx bx-check'></i>
 <span *ngIf="btndisable" class="spinner-border spinner-border-sm"></span>
 </button>
 </div>

 <div class="col-md-12 nopad mobile-body-report">
 <!-- Filter Card -->
 <div class="p-3">
 <div class="report-card-mobile shadow-sm p-3">
 <div class="form-group mb-2">
 <label class="small-label">User Role</label>
 <select class="form-control form-control-sm" [(ngModel)]="Selected_Rights" (change)="display()">
 <option *ngFor="let r of Rights_Row" [value]="r.value">{{r.label}}</option>
 </select>
 </div>
 <div class="form-group mb-2">
 <label class="small-label">Module Name</label>
 <select class="form-control form-control-sm" [(ngModel)]="Selected_Module" (change)="display()">
 <option *ngFor="let m of Module_Row" [value]="m.value">{{m.label}}</option>
 </select>
 </div>
 <button (click)="display()" class="btn btn-primary btn-block btn-sm shadow-sm mt-3">Filter Modules</button>
 </div>
 </div>

 <div class="spin_block" *ngIf="appservice.isload">
 <div class="d-flex justify-content-center p-5">
 <div class="spinner-border text-primary" role="status"></div>
 </div>
 </div>

 <!-- Permission Mapping Grid -->
 <div class="p-3 pt-0">
 <div class="d-flex justify-content-between align-items-center mb-3 px-1">
 <span class="text-muted small-label" style="font-size: 11px;">Mapped Items: {{Row.length}}</span>
 <div class="d-flex align-items-center">
 <label class="mr-2 mb-0 small-label" style="font-size: 11px;">Select All</label>
 <input type="checkbox" [(ngModel)]="Selected" (change)="select()" style="width: 20px; height: 20px;">
 </div>
 </div>

 <div *ngFor="let rowData of Row; index as i" class="report-card-mobile shadow-sm mb-2" (click)="rowData.Check = !rowData.Check">
 <div class="d-flex align-items-center p-3">
 <div class="mr-3">
 <input type="checkbox" [(ngModel)]="rowData.Check" (click)="$event.stopPropagation()" style="width: 22px; height: 22px;">
 </div>
 <div class="flex-grow-1">
 <div class="d-flex justify-content-between mb-1">
 <span class="customer" style="font-size: 14px; font-weight: 700; color: #1e3c72;">{{rowData.Display_Name}}</span>
 </div>
 <div class="d-flex gap-2">
 <span class="loan-type-badge" style="font-size: 9px; padding: 1px 6px;">{{rowData.Module}}</span>
 <span class="text-muted" style="font-size: 10px;"><i class='bx bx-list-ol mr-1'></i>Order: {{rowData.Order_No}}</span>
 </div>
 </div>
 <div class="ml-2">
 <i [class]="rowData.Check ? 'bx bxs-check-circle text-primary' : 'bx bx-circle text-muted'" style="font-size: 20px;"></i>
 </div>
 </div>
 </div>
 </div>
 </div>
</div>
